// extracted by mini-css-extract-plugin
export default {"container":"entity_edit_container__fFab9","title":"entity_edit_title__Li4mm","form":"entity_edit_form__R6lT6","sticky":"entity_edit_sticky__rCtHm"};